function Friends({ color }) {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill={color}>
            <path d="M 8 2.5 a 4.5 4.5 0 1 0 0 9 a 4.5 4.5 0 0 0 0 -9 Z M 5.5 7 a 2.5 2.5 0 1 1 5 0 a 2.5 2.5 0 0 1 -5 0 Z m -0.25 6 A 4.75 4.75 0 0 0 0.5 17.75 A 3.25 3.25 0 0 0 3.75 21 h 8.5 a 3.25 3.25 0 0 0 3.25 -3.25 A 4.75 4.75 0 0 0 10.75 13 h -5.5 Z M 2.5 17.75 A 2.75 2.75 0 0 1 5.25 15 h 5.5 a 2.75 2.75 0 0 1 2.75 2.75 c 0 0.69 -0.56 1.25 -1.25 1.25 h -8.5 c -0.69 0 -1.25 -0.56 -1.25 -1.25 Z M 14 9.5 a 3.5 3.5 0 1 1 7 0 a 3.5 3.5 0 0 1 -7 0 Z M 17.5 8 a 1.5 1.5 0 1 0 0 3 a 1.5 1.5 0 0 0 0 -3 Z m 0 6.5 a 1 1 0 1 0 0 2 h 2.3 a 1.7 1.7 0 0 1 1.7 1.7 a 0.8 0.8 0 0 1 -0.8 0.8 h -3.2 a 1 1 0 1 0 0 2 h 3.2 a 2.8 2.8 0 0 0 2.8 -2.8 a 3.7 3.7 0 0 0 -3.7 -3.7 h -2.3 Z"></path>
        </svg>
    );
}

export default Friends;
